enum QueueRequestStatus {
  wip = 'wip',
  done = 'done',
}

interface IQueueRequest {
  id: string
  status: QueueRequestStatus
  isError: boolean
  answer: any
  process: Promise<any>
  forWaiting: Promise<any>
}

interface IQueueRequestResult {
  isReady: boolean
  isError: boolean
  result: any
  resolve: any
  reject: any
}

class HttpQueueClass {
  requests: IQueueRequest[] = []
  public async add(id: string): Promise<IQueueRequestResult> {
    const found = this.requests.find((el) => el.id === id)
    if (found && found.status === QueueRequestStatus.wip) {
      await found.forWaiting
      return {
        isReady: true,
        isError: found.isError,
        result: found.answer,
        resolve: undefined,
        reject: undefined,
      }
    }
    const queueRes: IQueueRequestResult = {
      isReady: false,
      isError: false,
      result: undefined,
      resolve: undefined,
      reject: undefined,
    }

    let justWaiting: any
    const queueEl: IQueueRequest = {
      id: id,
      status: QueueRequestStatus.wip,
      answer: undefined,
      process: new Promise((resolve, reject) => {
        queueRes.resolve = resolve
        queueRes.reject = reject
      }),
      isError: false,
      forWaiting: new Promise((resolve) => {
        justWaiting = resolve
      }),
    }

    queueEl.process
      .then((result: any) => {
        queueEl.answer = result
        queueEl.status = QueueRequestStatus.done
        setTimeout(() => {
          const index = this.requests.findIndex((el) => el.id === queueEl.id)
          if (index > -1) {
            this.requests.splice(index, 1)
          }
        }, 1500)
        justWaiting()
        justWaiting = undefined
      })
      .catch((error: any) => {
        queueEl.answer = error
        queueEl.status = QueueRequestStatus.done
        queueEl.isError = true
        const index = this.requests.findIndex((el) => el.id === queueEl.id)
        if (index > -1) {
          this.requests.splice(index, 1)
        }
        justWaiting()
        justWaiting = undefined
      })
    this.requests.push(queueEl)

    if (found && found.status === QueueRequestStatus.done) {
      const index = this.requests.findIndex((el) => el === found)
      if (index > -1) {
        this.requests.splice(index, 1)
      }
      const promise = new Promise<void>((resolve) => {
        setTimeout(() => {
          resolve()
        }, 3000)
      })
      await promise
    }

    return queueRes
  }
}
export const HttpQueue = new HttpQueueClass()
